/** Búsqueda de texto en listas: sin mayúsculas ni tildes, y cada palabra tiene que aparecer (en cualquier orden). */

export const sinTildes = (s: string) => s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

export interface OpcionBuscable {
  valor: string;
  etiqueta: string;
  /** Texto extra donde también se busca y que no se muestra (ej. el nombre simple de una tarea). */
  busqueda?: string;
}

export function filtrarOpciones<T extends OpcionBuscable>(opciones: T[], texto: string): T[] {
  const palabras = sinTildes(texto).split(/\s+/).filter(Boolean);
  if (palabras.length === 0) return opciones;
  return opciones.filter((o) => {
    const donde = sinTildes(`${o.etiqueta} ${o.busqueda ?? ""}`);
    return palabras.every((p) => donde.includes(p));
  });
}
